import { FC } from 'react';
import { Box, Skeleton } from '@mui/material';

import { styles } from './styles';

export const RoomCardSkeleton: FC = () => (
    <Box>
        <Box css={styles.container}>
            <Box css={styles.wrapper}>
                <Skeleton variant="rectangular" css={styles.imageSkeleton} />
                <Box css={styles.roomInfoSkeleton}>
                    <Skeleton variant="text" css={styles.skeletonMainInfo} />
                    <Skeleton variant="text" css={styles.skeletonMainInfo} />
                    <Skeleton variant="text" css={styles.skeletonMainInfo} />
                    <Skeleton variant="text" css={styles.skeletonSubInfo} />
                    <Skeleton variant="text" css={styles.skeletonSubInfo} />
                </Box>
            </Box>
        </Box>
    </Box>
);
